"use strict";
/**
 * Wearable Integration Enums
 *
 * Enum constants for the wearables integration (Phase 1).
 * Providers map to Terra API provider identifiers.
 * Data types map to Terra data stream types.
 *
 * @see docs/superpowers/plans/2026-03-14-wearables-integration-phase1.md — Task C1.1
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WearableCyclePhase = exports.wearableConnectionStatusValues = exports.WearableConnectionStatus = exports.PHASE1_ACTIVE_DATA_TYPES = exports.BACKFILL_DAYS = exports.wearableDataTypeValues = exports.WearableDataType = exports.TERRA_WIDGET_PROVIDERS_STRING = exports.WIDGET_PROVIDERS = exports.TERRA_PROVIDER_REVERSE = exports.TERRA_PROVIDER_NAME = exports.wearableProviderValues = exports.WearableProvider = void 0;
// ============================================================================
// WEARABLE PROVIDER
// ============================================================================
/**
 * Maps to Terra provider identifiers.
 * Covers all major wearable platforms + nutrition trackers (forward compat).
 */
exports.WearableProvider = {
    // Mobile-only (SDK)
    APPLE_HEALTH: 'apple_health',
    ANDROID_HEALTH_CONNECT: 'android_health_connect',
    // Web-API providers (Terra widget)
    OURA: 'oura',
    GARMIN: 'garmin',
    FITBIT: 'fitbit',
    WHOOP: 'whoop',
    SAMSUNG: 'samsung',
    GOOGLE_FIT: 'google_fit',
    POLAR: 'polar',
    WITHINGS: 'withings',
    AMAZFIT: 'amazfit', // Zepp Health
    SUUNTO: 'suunto',
    COROS: 'coros',
    // Nutrition trackers (deferred Phase 2 — enum defined for forward compat)
    CRONOMETER: 'cronometer',
    MY_FITNESS_PAL: 'my_fitness_pal',
};
exports.wearableProviderValues = Object.values(exports.WearableProvider);
// ============================================================================
// TERRA PROVIDER NAME MAPPING
// ============================================================================
/** Maps Stella provider values → Terra API enum values (used for widget/API calls) */
exports.TERRA_PROVIDER_NAME = {
    apple_health: 'APPLE',
    android_health_connect: 'HEALTH_CONNECT',
    oura: 'OURA',
    garmin: 'GARMIN',
    fitbit: 'FITBIT',
    whoop: 'WHOOP',
    samsung: 'SAMSUNG',
    google_fit: 'GOOGLE',
    polar: 'POLAR',
    withings: 'WITHINGS',
    amazfit: 'ZEPP', // Terra lists Zepp (Amazfit's parent company), not Amazfit directly
    suunto: 'SUUNTO',
    coros: 'COROS',
    cronometer: 'CRONOMETER',
    my_fitness_pal: 'MYFITNESSPAL',
};
/**
 * Maps Terra webhook provider strings → Stella provider values.
 * Source of truth: https://docs.tryterra.co/reference/health-and-fitness-api/supported-integrations
 * Includes aliases where Terra uses multiple enum values for the same provider
 * (e.g. GOOGLE + GOOGLEFIT both map to google_fit).
 */
exports.TERRA_PROVIDER_REVERSE = {
    APPLE: 'apple_health',
    HEALTH_CONNECT: 'android_health_connect',
    OURA: 'oura',
    GARMIN: 'garmin',
    FITBIT: 'fitbit',
    WHOOP: 'whoop',
    SAMSUNG: 'samsung',
    GOOGLE: 'google_fit',
    GOOGLEFIT: 'google_fit',
    POLAR: 'polar',
    WITHINGS: 'withings',
    ZEPP: 'amazfit',
    SUUNTO: 'suunto',
    COROS: 'coros',
    CRONOMETER: 'cronometer',
    MYFITNESSPAL: 'my_fitness_pal',
};
/** Providers that authenticate via Terra widget (web-API) */
exports.WIDGET_PROVIDERS = [
    'oura',
    'garmin',
    'fitbit',
    'whoop',
    'samsung',
    'google_fit',
    'polar',
    'withings',
    'amazfit',
    'suunto',
    'coros',
];
/** Terra widget `providers` param string, derived from WIDGET_PROVIDERS */
exports.TERRA_WIDGET_PROVIDERS_STRING = exports.WIDGET_PROVIDERS.map((p) => exports.TERRA_PROVIDER_NAME[p]).join(',');
// ============================================================================
// WEARABLE DATA TYPE
// ============================================================================
/**
 * Terra data stream types.
 * Phase 1 processes: SLEEP, DAILY, BODY, ACTIVITY.
 * MENSTRUATION and NUTRITION defined for schema forward-compat but not processed.
 */
exports.WearableDataType = {
    SLEEP: 'sleep',
    DAILY: 'daily',
    BODY: 'body',
    ACTIVITY: 'activity',
    MENSTRUATION: 'menstruation', // Deferred Phase 2
    NUTRITION: 'nutrition', // Deferred Phase 2
};
exports.wearableDataTypeValues = Object.values(exports.WearableDataType);
/** Days of historical data to backfill on first connection (1 skin turnover cycle) */
exports.BACKFILL_DAYS = 30;
/** Phase 1 active data types — used in processing logic, not schema */
exports.PHASE1_ACTIVE_DATA_TYPES = [
    'sleep',
    'daily',
    'body',
    'activity',
];
// ============================================================================
// WEARABLE CONNECTION STATUS
// ============================================================================
exports.WearableConnectionStatus = {
    ACTIVE: 'active',
    DISCONNECTED: 'disconnected',
    ERROR: 'error',
};
exports.wearableConnectionStatusValues = Object.values(exports.WearableConnectionStatus);
// ============================================================================
// CYCLE PHASE (future menstruation support)
// ============================================================================
exports.WearableCyclePhase = {
    FOLLICULAR: 'follicular',
    OVULATION: 'ovulation',
    LUTEAL: 'luteal',
    MENSTRUATION: 'menstruation',
};
//# sourceMappingURL=enums.js.map